import { XCircle } from "lucide-react";
import { Button } from "src/components/ui/button";

export default function SlackConnectError() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-midnight to-dark-teal text-white flex items-center justify-center p-4">
      <div className="bg-steel/30 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-steel/50 w-full max-w-md">
        <div className="flex items-center gap-4 mb-6">
          <XCircle className="h-12 w-12 text-red-400 flex-shrink-0" />
          <div>
            <h2 className="text-xl font-medium text-white mb-1">We're sorry</h2>
            <p className="text-slate-300">
              We couldn’t link your account. This may be because the link has expired or due to another issue. Please reach out for assistance.
            </p>
          </div>
        </div>
        <div className="flex justify-center">
          <Button 
            variant="primary" 
            size="lg" 
            onClick={() => {window.location.href="/"}}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
